/**
 * Pages of the StreamLain website the apps link to
 * (tsk-help-menu-platform-docs-1017). The base is the website of the build:
 * in local development the website dev server http://localhost:4317, in every
 * other build https://streamlain.de (card dec-help-docs-landing-1021, user
 * 21.10.2026), so a local app shows the local docs and an online app the live
 * ones.
 */
export type WebsiteLocale = 'de' | 'en';
export type WebsitePage = 'platformDocs' | 'releaseNotes' | 'status';

const WEBSITE_PAGE_PATHS: Record<WebsitePage, Record<WebsiteLocale, string>> = {
  platformDocs: { de: '/de/plattform/', en: '/en/platform/' },
  releaseNotes: { de: '/de/release-notes/', en: '/en/release-notes/' },
  status: { de: '/de/status/', en: '/en/status/' },
};

/** https on streamlain.de or a subdomain; http only on the own machine. */
function assertWebsiteBase(url: URL): void {
  const firstParty =
    url.protocol === 'https:' &&
    (url.hostname === 'streamlain.de' ||
      url.hostname.endsWith('.streamlain.de'));
  const local =
    url.protocol === 'http:' &&
    (url.hostname === 'localhost' || url.hostname === '127.0.0.1');
  if (!firstParty && !local) {
    throw new Error(`Invalid website base URL: ${url.origin}`);
  }
}

/** The address of a website page in a language, on the website of the build. */
export function resolveWebsiteUrl(
  base: string,
  page: WebsitePage,
  locale: WebsiteLocale
): string {
  const url = new URL(base);
  assertWebsiteBase(url);
  url.pathname = WEBSITE_PAGE_PATHS[page][locale];
  url.search = '';
  url.hash = '';
  return url.toString();
}

/** The website language of a UI language: English for en*, else German. */
export function websiteLocaleOf(language: string | undefined): WebsiteLocale {
  return language?.startsWith('en') ? 'en' : 'de';
}
